import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לדחייה האוטומטית",
    opening: localizedGenderNode(
      [
      "היום אני רק שם/ה לב — בלי לתקן."
    ],
      [
      "היום אני רק שם/ה לב — בלי לתקן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “משהו טוב הגיע אליי — ואני לא רוצה/ת לדחוף אותו החוצה.”"
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת איטית.",
      "בלב: “משהו טוב הגיע אליי — ואני לא רוצה/ת לדחוף אותו החוצה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איך אני מגיב/ה בדרך כלל למחמאה או להכרה? (מבטל/ת, צוחק/ת, מחליף/ה נושא)\n[כאן אני כותב]",
      "2. מה אני מרגיש/ה בגוף ברגע שמישהו אומר לי משהו טוב?\n[כאן אני כותב]",
      "3. איזה משפט פנימי קופץ מיד?\n[כאן אני כותב]"
    ],
      [
      "1. איך אני מגיב/ה בדרך כלל למחמאה או להכרה? (מבטל/ת, צוחק/ת, מחליף/ה נושא)\n[כאן אני כותב]",
      "2. מה אני מרגיש/ה בגוף ברגע שמישהו אומר לי משהו טוב?\n[כאן אני כותב]",
      "3. איזה משפט פנימי קופץ מיד?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "התגובה שלי היא הרגל — לא אמת."
    ],
      [
      "סגירה",
      "התגובה שלי היא הרגל — לא אמת."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: כשמגיע משהו טוב — אני רק שם/ה לב מה קורה בי.",
      "פעם אחת היום: כשמגיע משהו טוב — אני רק שם/ה לב מה קורה בי."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה מפחיד בקבלה",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת מה באמת מאיים בקבלה."
    ],
      [
      "היום אני בודק/ת מה באמת מאיים בקבלה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה מפחיד אותי בלתת למחמאה להיכנס?\n[כאן אני כותב]",
      "2. איזו מחשבה מגיעה מיד אחרי מחמאה? (\"הם מגזימים\", \"זה לא באמת\")\n[כאן אני כותב]",
      "3. מה אני מפחד/ת שיקרה אם אאמין לה?\n[כאן אני כותב]"
    ],
      [
      "1. מה מפחיד אותי בלתת למחמאה להיכנס?\n[כאן אני כותב]",
      "2. איזו מחשבה מגיעה מיד אחרי מחמאה? (\"הם מגזימים\", \"זה לא באמת\")\n[כאן אני כותב]",
      "3. מה אני מפחד/ת שיקרה אם אאמין לה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לפעמים הפחד הוא מחשיפה — לא משקר."
    ],
      [
      "סגירה",
      "לפעמים הפחד הוא מחשיפה — לא משקר."
    ]
    ),
    action: localizedGenderNode(
      "נשימה + משפט: “מותר לי להרגיש אי־נוחות.”",
      "נשימה + משפט: “מותר לי להרגיש אי־נוחות.”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "ההרגל להקטין",
    opening: localizedGenderNode(
      [
      "היום אני מזהה הקטנה — בלי לשפוט."
    ],
      [
      "היום אני מזהה הקטנה — בלי לשפוט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. באילו מילים אני מקטין/ה את עצמי?\n[כאן אני כותב]",
      "2. מאיפה למדתי שזה “מסוכן” לבלוט?\n[כאן אני כותב]",
      "3. מה זה מנסה להגן עליי ממנו?\n[כאן אני כותב]"
    ],
      [
      "1. באילו מילים אני מקטין/ה את עצמי?\n[כאן אני כותב]",
      "2. מאיפה למדתי שזה “מסוכן” לבלוט?\n[כאן אני כותב]",
      "3. מה זה מנסה להגן עליי ממנו?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הקטנה היא הגנה ישנה."
    ],
      [
      "סגירה",
      "הקטנה היא הגנה ישנה."
    ]
    ),
    action: localizedGenderNode(
      "כשאני מקטין/ה — אני רק אומר/ת: “שמתי לב.”",
      "כשאני מקטין/ה — אני רק אומר/ת: “שמתי לב.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "מחמאה ≠ מחויבות",
    opening: localizedGenderNode(
      [
      "היום אני מבדיל/ה בין קבלה לבין עומס."
    ],
      [
      "היום אני מבדיל/ה בין קבלה לבין עומס."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזו מחויבות אני מדמיין/ת שנולדת ממחמאה?\n[כאן אני כותב]",
      "2. האם מחמאה באמת מרוצהת אותי למשהו?\n[כאן אני כותב]",
      "3. איזו מחשבה מרגיעה אפשרית?\n[כאן אני כותב]"
    ],
      [
      "1. איזו מחויבות אני מדמיין/ת שנולדת ממחמאה?\n[כאן אני כותב]",
      "2. האם מחמאה באמת מרוצהת אותי למשהו?\n[כאן אני כותב]",
      "3. איזו מחשבה מרגיעה אפשרית?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "קבלה לא מרוצהת שלמות."
    ],
      [
      "סגירה",
      "קבלה לא מרוצהת שלמות."
    ]
    ),
    action: localizedGenderNode(
      "משפט: “מחמאה היא רגע, לא חוזה.”",
      "משפט: “מחמאה היא רגע, לא חוזה.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הישגים שלא ספרתי",
    opening: localizedGenderNode(
      [
      "היום אני סופר/ת גם את מה שלא קיבל applause."
    ],
      [
      "היום אני סופר/ת גם את מה שלא קיבל applause."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. שלושה דברים שהשגתי — ולא עצרתי להכיר בהם\n[כאן אני כותב]",
      "2. למה ביטלתי אותם?\n[כאן אני כותב]",
      "3. איך זה מרגיש לראות אותם כתובים?\n[כאן אני כותב]"
    ],
      [
      "1. שלושה דברים שהשגתי — ולא עצרתי להכיר בהם\n[כאן אני כותב]",
      "2. למה ביטלתי אותם?\n[כאן אני כותב]",
      "3. איך זה מרגיש לראות אותם כתובים?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "לא כל הישג בוחר/ת קהל."
    ],
      [
      "סגירה",
      "לא כל הישג בוחר/ת קהל."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב הישג אחד ביומן — ולסגור.",
      "לכתוב הישג אחד ביומן — ולסגור."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "“זה היה מזל”",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת את סיפור המזל."
    ],
      [
      "היום אני בודק/ת את סיפור המזל."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מתי אני אומר/ת “זה סתם מזל”?\n[כאן אני כותב]",
      "2. איזה חלק בי כן היה מעורב בזה?\n[כאן אני כותב]",
      "3. איך נשמעת הכרה מינימלית בלי יהירות?\n[כאן אני כותב]"
    ],
      [
      "1. מתי אני אומר/ת “זה סתם מזל”?\n[כאן אני כותב]",
      "2. איזה חלק בי כן היה מעורב בזה?\n[כאן אני כותב]",
      "3. איך נשמעת הכרה מינימלית בלי יהירות?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "להכיר במאמץ זה לא להתנפח."
    ],
      [
      "סגירה",
      "להכיר במאמץ זה לא להתנפח."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד: “היה פה גם משהו שלי.”",
      "משפט אחד: “היה פה גם משהו שלי.”"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "ניסוי: רק “תודה”",
    opening: localizedGenderNode(
      [
      "היום אני לא מסביר/ה, לא מבטל/ת."
    ],
      [
      "היום אני לא מסביר/ה, לא מבטל/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה הכי קשה לי להגיד — “תודה” או לשתוק?\n[כאן אני כותב]",
      "2. מה עולה בי כשאני רק אומר/ת תודה?\n[כאן אני כותב]",
      "3. מה לא קרה למרות הפחד?\n[כאן אני כותב]"
    ],
      [
      "1. מה הכי קשה לי להגיד — “תודה” או לשתוק?\n[כאן אני כותב]",
      "2. מה עולה בי כשאני רק אומר/ת תודה?\n[כאן אני כותב]",
      "3. מה לא קרה למרות הפחד?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "פשטות יכולה להיות בטוחה."
    ],
      [
      "סגירה",
      "פשטות יכולה להיות בטוחה."
    ]
    ),
    action: localizedGenderNode(
      "מחמאה אחת → רק “תודה”.",
      "מחמאה אחת → רק “תודה”."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "לשאת אי־נוחות (ACT)",
    opening: localizedGenderNode(
      [
      "היום אני נשאר/ת עם התחושה דקה."
    ],
      [
      "היום אני נשאר/ת עם התחושה דקה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזו תחושה עולה כשאני מקבל/ת משהו טוב?\n[כאן אני כותב]",
      "2. תרגול דקה: אני נותן/ת לתחושה להיות — בלי פעולה.\n[כאן אני כותב]",
      "3. מה קרה אחרי הדקה?\n[כאן אני כותב]"
    ],
      [
      "1. איזו תחושה עולה כשאני מקבל/ת משהו טוב?\n[כאן אני כותב]",
      "2. תרגול דקה: אני נותן/ת לתחושה להיות — בלי פעולה.\n[כאן אני כותב]",
      "3. מה קרה אחרי הדקה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אי־נוחות לא הורגת — היא חולפת."
    ],
      [
      "סגירה",
      "אי־נוחות לא הורגת — היא חולפת."
    ]
    ),
    action: localizedGenderNode(
      "דקה אחת בלבד.",
      "דקה אחת בלבד."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "קבלה בלי השוואה",
    opening: localizedGenderNode(
      [
      "היום אני מקבל/ת בלי להשוות."
    ],
      [
      "היום אני מקבל/ת בלי להשוות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. למי אני משווה את המחמאה שקיבלתי?\n[כאן אני כותב]",
      "2. מה המחיר של ההשוואה הזו?\n[כאן אני כותב]",
      "3. איך זה מרגיש להשאיר את זה אצלי?\n[כאן אני כותב]"
    ],
      [
      "1. למי אני משווה את המחמאה שקיבלתי?\n[כאן אני כותב]",
      "2. מה המחיר של ההשוואה הזו?\n[כאן אני כותב]",
      "3. איך זה מרגיש להשאיר את זה אצלי?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מה שטוב לי — לא לוקח מאף אחד."
    ],
      [
      "סגירה",
      "מה שטוב לי — לא לוקח מאף אחד."
    ]
    ),
    action: localizedGenderNode(
      "עצירת השוואה אחת היום.",
      "עצירת השוואה אחת היום."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "ערך עצמי בלי הוכחה",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת מי אני בלי להוכיח."
    ],
      [
      "היום אני בודק/ת מי אני בלי להוכיח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה אני מנסה להוכיח דרך דחיית מחמאות?\n[כאן אני כותב]",
      "2. מה קורה אם אני לא מוכיח/ה כלום?\n[כאן אני כותב]",
      "3. איזה משפט יציב אני בוחר/ת?\n[כאן אני כותב]"
    ],
      [
      "1. מה אני מנסה להוכיח דרך דחיית מחמאות?\n[כאן אני כותב]",
      "2. מה קורה אם אני לא מוכיח/ה כלום?\n[כאן אני כותב]",
      "3. איזה משפט יציב אני בוחר/ת?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הערך שלי לא תלוי בהגנה."
    ],
      [
      "סגירה",
      "הערך שלי לא תלוי בהגנה."
    ]
    ),
    action: localizedGenderNode(
      "לחזור למשפט היציב פעם אחת.",
      "לחזור למשפט היציב פעם אחת."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "לקבל בלי להתנצל",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב להתנצלות המיותרת."
    ],
      [
      "היום אני שם/ה לב להתנצלות המיותרת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איפה אני מתנצל/ת כשלא בוחר/ת?\n[כאן אני כותב]",
      "2. מה אני מפחד/ת שיחשבו עליי?\n[כאן אני כותב]",
      "3. איך נראית קבלה בלי התנצלות?\n[כאן אני כותב]"
    ],
      [
      "1. איפה אני מתנצל/ת כשלא בוחר/ת?\n[כאן אני כותב]",
      "2. מה אני מפחד/ת שיחשבו עליי?\n[כאן אני כותב]",
      "3. איך נראית קבלה בלי התנצלות?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "קבלה שקטה היא בגרות."
    ],
      [
      "סגירה",
      "קבלה שקטה היא בגרות."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת — לא להתנצל.",
      "פעם אחת — לא להתנצל."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "לשנות שפה פנימית",
    opening: localizedGenderNode(
      [
      "היום אני משנה מילה אחת."
    ],
      [
      "היום אני משנה מילה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איזו מילה מקטינה אני אומר/ת לעצמי אחרי הצלחה?\n[כאן אני כותב]",
      "2. איך אותה אמת נשמעת בשפה אנושית?\n[כאן אני כותב]",
      "3. איזו מילה חדשה אני בוחר/ת?\n[כאן אני כותב]"
    ],
      [
      "1. איזו מילה מקטינה אני אומר/ת לעצמי אחרי הצלחה?\n[כאן אני כותב]",
      "2. איך אותה אמת נשמעת בשפה אנושית?\n[כאן אני כותב]",
      "3. איזו מילה חדשה אני בוחר/ת?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "מילים בונות בית."
    ],
      [
      "סגירה",
      "מילים בונות בית."
    ]
    ),
    action: localizedGenderNode(
      "החלפה אחת בלבד.",
      "החלפה אחת בלבד."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "לאפשר לטוב להישאר",
    opening: localizedGenderNode(
      [
      "היום אני לא ממהר/ת לנקות את הטוב."
    ],
      [
      "היום אני לא ממהר/ת לנקות את הטוב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה קורה בי כשאני נותן/ת לטוב להישאר רגע?\n[כאן אני כותב]",
      "2. איזה ערך זה משרת בי?\n[כאן אני כותב]",
      "3. מה אני מבטיח/ה לעצמי כשעולה דחייה?\n[כאן אני כותב]"
    ],
      [
      "1. מה קורה בי כשאני נותן/ת לטוב להישאר רגע?\n[כאן אני כותב]",
      "2. איזה ערך זה משרת בי?\n[כאן אני כותב]",
      "3. מה אני מבטיח/ה לעצמי כשעולה דחייה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "טוב יכול להיות יציב."
    ],
      [
      "סגירה",
      "טוב יכול להיות יציב."
    ]
    ),
    action: localizedGenderNode(
      "לעצור 10 שניות עם משהו טוב.",
      "לעצור 10 שניות עם משהו טוב."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת מסע — בלי לשנות את מי שאני."
    ],
      [
      "היום אני מסיים/ת מסע — בלי לשנות את מי שאני."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "נשימה אחת."
    ],
      [
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה השתנה בדרך שבה אני פוגש/ת מחמאות?\n[כאן אני כותב]",
      "2. מה נהיה קצת פחות מאיים?\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים:\n[כאן אני כותב]"
    ],
      [
      "1. מה השתנה בדרך שבה אני פוגש/ת מחמאות?\n[כאן אני כותב]",
      "2. מה נהיה קצת פחות מאיים?\n[כאן אני כותב]",
      "3. משפט חזרה לימים קשים:\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית",
      "אני לא רוצה/ת להדוף את הטוב.",
      "אני יכול/ה לתת לו להיות.",
      "אני נשאר/ת איתי —",
      "וזה מספיק."
    ],
      [
      "סגירה סופית",
      "אני לא רוצה/ת להדוף את הטוב.",
      "אני יכול/ה לתת לו להיות.",
      "אני נשאר/ת איתי —",
      "וזה מספיק."
    ]
    ),
    action: localizedGenderNode(
      "פעולה אחת שמסמלת קבלה שקטה (נשימה, כתיבה, הליכה).",
      "פעולה אחת שמסמלת קבלה שקטה (נשימה, כתיבה, הליכה)."
    ),
  },
].map(buildNormalizedDay);

export const difficultyReceivingComplimentsAchievementsBlueprintHe = buildNormalizedPilotBlueprint({
  id: "difficulty_receiving_compliments_achievements_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "difficulty_receiving_compliments_achievements",
  category: "general",
  journeyName: {
    he: "קושי לקבל מחמאות והישגים",
    en: "Difficulty Receiving Compliments and Achievements",
    es: "Dificultad para Recibir Halagos y Logros",
  },
  days,
});

export default difficultyReceivingComplimentsAchievementsBlueprintHe;
